import React, {forwardRef} from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const SelectInput = forwardRef(({
                                    label,
                                    name,
                                    value,
                                    onChange,
                                    options,
                                    placeholder,
                                    multiple = false,
                                    className = '',
                                    getOptionValue,
                                    disabled = false,
                                    creatable = false,
                                    fullWidth = false,
                                    wrapLabel = false
                                }, ref) => {
    const SelectComponent = creatable ? CreatableSelect : Select;
    const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;

    const customFilterOption = (option, searchText) => {
        const label = option.label.toLowerCase();
        const code = option.data.code?.toLowerCase() || '';
        const search = searchText.toLowerCase();

        return label.includes(search) || code.includes(search);
    };

    return (
        <div>
            <label htmlFor={name}>{label}</label>
            <SelectComponent
                ref={ref}
                styles={{
                    control: (base) => ({
                        ...base,
                        width: fullWidth ? "100%" : "auto",
                        minWidth: fullWidth ? 0 : "max-content"
                    }),
                    menu: (base) => ({
                        ...base,
                        width: fullWidth ? "100%" : "max-content",
                        minWidth: "100%"
                    }),
                    valueContainer: (base) => ({
                        ...base,
                        whiteSpace: wrapLabel ? 'normal' : base.whiteSpace,
                        overflow: wrapLabel ? 'visible' : base.overflow
                    }),
                    singleValue: (base) => ({
                        ...base,
                        whiteSpace: wrapLabel ? 'normal' : base.whiteSpace,
                        overflow: wrapLabel ? 'visible' : base.overflow,
                        textOverflow: wrapLabel ? 'clip' : base.textOverflow,
                        maxWidth: wrapLabel ? '100%' : base.maxWidth,
                        position: wrapLabel ? 'static' : base.position,
                        transform: wrapLabel ? 'none' : base.transform
                    }),
                    option: (base) => ({
                        ...base,
                        whiteSpace: wrapLabel ? 'normal' : base.whiteSpace,
                        wordBreak: wrapLabel ? 'break-word' : base.wordBreak
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 10000
                    }),
                }}
                isDisabled={disabled}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                getOptionValue={getOptionValue}
                options={options}
                isMulti={multiple}
                placeholder={placeholder || 'Vyberte...'}
                className={`react-select-container ${className}`}
                classNamePrefix="react-select"
                filterOption={customFilterOption}
                menuPortalTarget={menuPortalTarget}
                menuPosition="fixed"
            />
        </div>
    );
});

export default SelectInput;
